import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { LocalizedLink } from "./LocalizedLink";
import { useLanguage } from "../i18n/LanguageProvider";

export const Footer = () => {
  const { t } = useLanguage();
  const quickLinks = [
    { key: "projects", label: "Projects", href: "/projects" },
    { key: "articles", label: "Articles", href: "/articles" },
    { key: "aiResources", label: "AI Resources", href: "/ai-resources" },
    { key: "testimonials", label: "Testimonials", href: "/testimonials" },
    { key: "changelog", label: "Changelog", href: "/changelog" },
  ];

  return (
    <footer
      data-testid="footer-section"
      className="py-16 md:py-24 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Quick Links */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 mb-12"
        >
          {quickLinks.map((link, i) => (
            <span key={link.label} className="flex items-center">
              <LocalizedLink 
                to={link.href}
                className="text-sm text-zinc-500 hover:text-white font-medium transition-colors duration-200"
              >
                {t(`nav.${link.key}`, link.label)}
              </LocalizedLink>
              {i < quickLinks.length && (
                <span className="text-zinc-800 ml-6">·</span>
              )}
            </span>
          ))}
          <LocalizedLink
            to="/personal-space"
            data-testid="personal-space-link"
            className="text-sm text-zinc-500 hover:text-white font-medium transition-colors duration-200 flex items-center gap-1.5"
          >
            <Sparkles size={14} className="text-violet-400/70" />
            {t("nav.personalSpace")}
          </LocalizedLink>
        </motion.div>

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-600">
            {t("footer.builtWith")}
          </p>
          <p className="text-xs text-zinc-700">
            {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
};
